import { GoToCheckout } from './GoToCheckout';

export default GoToCheckout;
